<!-- ENVIRONMENT -->
<div class="environment-configurations" *ngIf="!headerModel.isProduction || headerModel.isTestingEnvironment">
  <ng-container *ngIf="headerModel.isTestingEnvironment">
    <div class="environment-configurations__ribbon">
      <select id="countrySelection" (change)="onCountrySelectionChange($event)">
        <option *ngFor="let country of countries" [value]="country.code" [selected]="_countryCode === country.code">
          {{country.value}}</option>
      </select>
    </div>
    <select id="environmentSelection" (change)="onEnvironmentSelectionChange($event)">
      <option *ngFor="let environment of environments" [value]="environment" [selected]="_environment === environment">
        {{ environment }}</option>
    </select>
  </ng-container>
</div>
<!-- PUBLIC NAVIGATION -->
<div class="pantry" *ngIf="showPublicNavigationBar">
  <header class="nav"
    [ngClass]="{ 'is-open': navigation.mobileHamburgerMenuOpen, 'is-submenu-open' : navigation.activeMobileSubMenu }">
    <div class="navbar" role="navigation">
      <a href="/" class="navbar__brand">
        <img class="logo-fs-mk" [src]="navigation.logoPath" />
      </a>
      <button (click)="closeSubMenu()" class="navbar__hamburger-return">
        {{ 'navigation.back-to-menu' | translate }}
      </button>
      <button class="navbar__hamburger" (click)="openCloseHamburgerMenu()">
        <span class="navbar__hamburger-indicator"></span>
      </button>
      <nav class="nav-menu">
        <ul class="nav-menu__items">
          <li class="nav-menu__item" *ngIf="hasLandingPageFor('smeLoans', countryCode)">
            <a [href]="landingPagePathFor('smeLoans', countryCode)">
              {{ 'navigation.borrow' | translate }}
            </a>
          </li>
          <li class="nav-menu__item" *ngIf="hasLandingPageFor('borrow', countryCode)">
            <a [href]="landingPagePathFor('borrow', countryCode)">
              {{ 'navigation.borrow' | translate }}
            </a>
          </li>
          <li class="nav-submenu" *ngIf="hasLandingPageFor('smeFinancing', countryCode)"
            [ngClass]="{ 'is-open' : navigation.desktopSubMenuOpen.borrow }" #borrowDesktopMenu>
            <span class="nav-submenu__title" tabindex="0" (click)="toggleDesktopSubMenu('borrow')">
              {{ 'navigation.borrow' | translate }}
            </span>
            <div class="nav-submenu__container">
              <ul class="nav-submenu__items">
                <li *ngIf="hasLandingPageFor('microFinancing', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('microFinancing', countryCode)">
                    <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_microfinance_icon.svg" />
                    <div>{{ 'navigation.mega-menu-borrow.micro-financing' | translate }}
                      <p class="nav-submenu__item-subtitle">
                        {{ 'navigation.mega-menu-borrow.micro-financing-description' | translate }}
                      </p>
                    </div>
                  </a>
                </li>
                <li *ngIf="hasLandingPageFor('businessTermFinancing', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('businessTermFinancing', countryCode)">
                    <img class="icon nav_submenu__item-icon"
                      src="assets/img/icon/menu_business_term_financing_icon.svg" />
                    <div>{{ 'navigation.mega-menu-borrow.business-term-financing' | translate }}
                      <p class="nav-submenu__item-subtitle">
                        {{ 'navigation.mega-menu-borrow.business-term-financing-description' | translate }}
                      </p>
                    </div>
                  </a>
                </li>
                <li *ngIf="hasLandingPageFor('invoiceFinancing', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('invoiceFinancing', countryCode)">
                    <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_invoice_financing_icon.svg" />
                    <div>{{ 'navigation.mega-menu-borrow.invoice-financing' | translate }}
                      <p class="nav-submenu__item-subtitle">
                        {{ 'navigation.mega-menu-borrow.invoice-financing-description' | translate }}
                      </p>
                    </div>
                  </a>
                </li>
                <li *ngIf="hasLandingPageFor('dealerFinancing', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('dealerFinancing', countryCode)">
                    <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_dealer_financing_icon.svg" />
                    <div>{{ 'navigation.mega-menu-borrow.dealer-financing' | translate }}
                      <p class="nav-submenu__item-subtitle">
                        {{ 'navigation.mega-menu-borrow.dealer-financing-description' | translate }}
                      </p>
                    </div>
                  </a>
                </li>
                <li *ngIf="hasLandingPageFor('microCreditLine', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('microCreditLine', countryCode)">
                    <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_micro_credit_line_icon.svg" />
                    <div>{{ 'navigation.mega-menu-borrow.micro-credit-line' | translate }}
                      <p class="nav-submenu__item-subtitle">
                        {{ 'navigation.mega-menu-borrow.micro-credit-line' | translate }}
                      </p>
                    </div>
                  </a>
                </li>
                <li class="nav-submenu__item">
                  <a [href]="landingPagePathFor('smeFinancing', countryCode)" class="btn btn--small btn--link">
                    {{ 'navigation.mega-menu-borrow.view-all' | translate }}
                  </a>
                </li>
              </ul>
              <div class="nav-submenu__aside" *ngIf="hasLandingPageFor('personalisedFinancing', countryCode)">
                <img src="assets/img/icon/light_bulb.svg" class="margin-bottom-15">
                <p class="margin-bottom-15">{{ 'navigation.mega-menu-borrow.not-sure' | translate }}
                  <br>
                  {{ 'navigation.mega-menu-borrow.let-us-help' | translate }}
                </p>
                <a [href]="landingPagePathFor('personalisedFinancing', countryCode)"
                  class="btn btn--primary btn--block">
                  {{ 'navigation.mega-menu-borrow.button-caption' | translate }}
                </a>
              </div>
            </div>
          </li>
          <li class="nav-menu__item" *ngIf="CONFIGURATION.navigation.getFunding.show">
            <a [href]="CONFIGURATION.navigation.getFunding.link">
              {{ 'navigation.get-funding' | translate }}
            </a>
          </li>
          <li class="nav-menu__item">
            <a *ngIf="hasLandingPageFor('invest', countryCode)" [href]="landingPagePathFor('invest', countryCode)">
              {{ 'navigation.invest' | translate }}
            </a>
            <a *ngIf="hasLandingPageFor('p2pInvestment', countryCode)"
              [href]="landingPagePathFor('p2pInvestment', countryCode)">
              {{ 'navigation.invest' | translate }}
            </a>
          </li>
          <li class="nav-submenu"
            *ngIf="hasLandingPageFor('aboutUs', countryCode) && landingPageProperties('aboutUs').dropdown.includes(countryCode)"
            [ngClass]="{ 'is-open' : navigation.desktopSubMenuOpen.about }" #aboutDesktopMenu>
            <span class="nav-submenu__title" tabindex="0" (click)="toggleDesktopSubMenu('about')">
              {{ 'navigation.about-us' | translate }}
            </span>
            <div class="nav-submenu__container">
              <ul class="nav-submenu__items">
                <li *ngIf="hasLandingPageFor('ourCompany', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('ourCompany', countryCode)">
                    {{ 'navigation.our-company' | translate }}
                  </a>
                </li>
                <li *ngIf="hasLandingPageFor('leadershipTeam', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('leadershipTeam', countryCode)">
                    {{ 'navigation.leadership-team' | translate }}
                  </a>
                </li>
                <li *ngIf="hasLandingPageFor('inTheNews', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('inTheNews', countryCode)">
                    {{ 'navigation.in-the-news' | translate }}
                  </a>
                </li>
                <li *ngIf="hasLandingPageFor('career', countryCode)" class="nav-submenu__item">
                  <a [href]="landingPagePathFor('career', countryCode)">
                    {{ 'navigation.careers' | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-menu__item" *ngIf="!landingPageProperties('aboutUs').dropdown.includes(countryCode)">
            <a [href]="landingPagePathFor('aboutUs', countryCode)">
              {{ 'navigation.about-us' | translate }}
            </a>
          </li>
          <li class="nav-menu__item" *ngIf="hasLandingPageFor('refer', countryCode)">
            <a [href]="landingPagePathFor('refer', countryCode)">
              {{ 'navigation.refer' | translate }}
            </a>
          </li>
          <ng-container>
            <li class="nav-menu__item" *ngIf="CONFIGURATION.navigation.blog.show">
              <a href="#" [href]="CONFIGURATION.navigation.blog.link">
                {{ 'navigation.blog' | translate }}
              </a>
            </li>
            <li class="nav-menu__item">
              <a href="#" routerLink="/progress">
                {{ 'navigation.statistic' | translate }}
              </a>
            </li>
            <li class="nav-menu__item" *ngIf="CONFIGURATION.help.show.publicPage">
              <a [href]="faqLink" target="_blank">{{ 'navigation.help' | translate }}</a>
            </li>
          </ng-container>
          <li class="nav-menu__item nav-menu__item--separator"></li>
          <ng-container *ngIf="!navigationConfiguration.loginDropDown">
            <li class="nav-menu__item">
              <a [ngClass]="{ 'btn btn--primary' : countryCode === 'ID'}" href="#" routerLink="/log-in">
                {{ 'navigation.log-in' | translate }}
              </a>
            </li>
          </ng-container>
          <ng-container *ngIf="navigationConfiguration.loginDropDown">
            <ng-container *ngTemplateOutlet="newLoginSubNavMenuDesktop"></ng-container>
          </ng-container>

          <li class="nav-menu__item" *ngIf="navigationConfiguration.exposeSignUpMenu && !headerModel.isLoggedIn">
            <a class="btn btn--primary" href="#" [href]="landingPagePathFor('signUp', countryCode)">
              {{ 'navigation.sign-up' | translate }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <nav class="nav-menu nav-menu--hamburger">
      <ul class="nav-menu__items">
        <li class="nav-menu__item" *ngIf="hasLandingPageFor('smeLoans', countryCode)">
          <a [href]="landingPagePathFor('smeLoans', countryCode)">
            {{ 'navigation.borrow' | translate }}
          </a>
        </li>
        <li class="nav-menu__item" *ngIf="hasLandingPageFor('borrow', countryCode)">
          <a [href]="landingPagePathFor('borrow', countryCode)">
            {{ 'navigation.borrow' | translate }}
          </a>
        </li>
        <li class="nav-submenu" *ngIf="hasLandingPageFor('smeFinancing', countryCode)"
          [ngClass]="{ 'is-open' : navigation.activeMobileSubMenu === 'borrow' }">
          <span (click)="navigation.activeMobileSubMenu = 'borrow'" class="nav-submenu__title" tabindex="0">
            {{ 'navigation.borrow' | translate }}
          </span>
          <div class="nav-submenu__container">
            <ul class="nav-submenu__items">
              <li *ngIf="hasLandingPageFor('microFinancing', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('microFinancing', countryCode)">
                  <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_microfinance_icon.svg" />
                  <div>{{ 'navigation.mega-menu-borrow.micro-financing' | translate }}
                    <p class="nav-submenu__item-subtitle">
                      {{ 'navigation.mega-menu-borrow.micro-financing-description' | translate }}
                    </p>
                  </div>
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('businessTermFinancing', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('businessTermFinancing', countryCode)">
                  <img class="icon nav_submenu__item-icon"
                    src="assets/img/icon/menu_business_term_financing_icon.svg" />
                  <div>{{ 'navigation.mega-menu-borrow.business-term-financing' | translate }}
                    <p class="nav-submenu__item-subtitle">
                      {{ 'navigation.mega-menu-borrow.business-term-financing-description' | translate }}
                    </p>
                  </div>
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('invoiceFinancing', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('invoiceFinancing', countryCode)">
                  <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_invoice_financing_icon.svg" />
                  <div>{{ 'navigation.mega-menu-borrow.invoice-financing' | translate }}
                    <p class="nav-submenu__item-subtitle">
                      {{ 'navigation.mega-menu-borrow.invoice-financing-description' | translate }}
                    </p>
                  </div>
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('dealerFinancing', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('dealerFinancing', countryCode)">
                  <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_dealer_financing_icon.svg" />
                  <div>{{ 'navigation.mega-menu-borrow.dealer-financing' | translate }}
                    <p class="nav-submenu__item-subtitle">
                      {{ 'navigation.mega-menu-borrow.dealer-financing-description' | translate }}
                    </p>
                  </div>
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('microCreditLine', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('microCreditLine', countryCode)">
                  <img class="icon nav_submenu__item-icon" src="assets/img/icon/menu_micro_credit_line_icon.svg" />
                  <div>{{ 'navigation.mega-menu-borrow.micro-credit-line' | translate }}
                    <p class="nav-submenu__item-subtitle">
                      {{ 'navigation.mega-menu-borrow.micro-credit-line' | translate }}
                    </p>
                  </div>
                </a>
              </li>
              <li class="nav-submenu__item">
                <a [href]="landingPagePathFor('smeFinancing', countryCode)" class="btn btn--small btn--link">
                  {{ 'navigation.mega-menu-borrow.view-all' | translate }}
                </a>
              </li>
            </ul>
            <div class="nav-submenu__aside" *ngIf="hasLandingPageFor('personalisedFinancing', countryCode)">
              <img src="assets/img/icon/light_bulb.svg" class="margin-bottom-15">
              <p class="margin-bottom-15">{{ 'navigation.mega-menu-borrow.not-sure' | translate }}
                <br>
                {{ 'navigation.mega-menu-borrow.let-us-help' | translate }}
              </p>
              <a [href]="landingPagePathFor('personalisedFinancing', countryCode)" class="btn btn--primary btn--block">
                {{ 'navigation.mega-menu-borrow.button-caption' | translate }}
              </a>
            </div>
          </div>
        </li>
        <li class="nav-menu__item" *ngIf="CONFIGURATION.navigation.getFunding.show">
          <a [href]="CONFIGURATION.navigation.getFunding.link">
            {{ 'navigation.get-funding' | translate }}
          </a>
        </li>
        <li class="nav-menu__item">
          <a *ngIf="hasLandingPageFor('invest', countryCode)" [href]="landingPagePathFor('invest', countryCode)">
            {{ 'navigation.invest' | translate }}
          </a>
          <a *ngIf="hasLandingPageFor('p2pInvestment', countryCode)"
            [href]="landingPagePathFor('p2pInvestment', countryCode)">
            {{ 'navigation.invest' | translate }}
          </a>
        </li>
        <li
          *ngIf="hasLandingPageFor('aboutUs', countryCode) && landingPageProperties('aboutUs').dropdown.includes(countryCode)"
          class="nav-submenu" [ngClass]="{ 'is-open' : navigation.activeMobileSubMenu === 'about' }">
          <span (click)="navigation.activeMobileSubMenu = 'about'" class="nav-submenu__title" tabindex="0">
            {{ 'navigation.about-us' | translate }}
          </span>
          <div class="nav-submenu__container">
            <ul class="nav-submenu__items">
              <li *ngIf="hasLandingPageFor('ourCompany', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('ourCompany', countryCode)">
                  {{ 'navigation.our-company' | translate }}
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('leadershipTeam', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('leadershipTeam', countryCode)">
                  {{ 'navigation.leadership-team' | translate }}
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('inTheNews', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('inTheNews', countryCode)">
                  {{ 'navigation.in-the-news' | translate }}
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('career', countryCode)" class="nav-submenu__item">
                <a [href]="landingPagePathFor('career', countryCode)">
                  {{ 'navigation.careers' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-menu__item" *ngIf="!landingPageProperties('aboutUs').dropdown.includes(countryCode)">
          <a [href]="landingPagePathFor('aboutUs', countryCode)">
            {{ 'navigation.about-us' | translate }}
          </a>
        </li>
        <li class="nav-menu__item" *ngIf="hasLandingPageFor('refer', countryCode)">
          <a [href]="landingPagePathFor('refer', countryCode)">
            {{ 'navigation.refer' | translate }}
          </a>
        </li>
        <ng-container>
          <li class="nav-menu__item" *ngIf="CONFIGURATION.navigation.blog.show">
            <a href="#" [href]="CONFIGURATION.navigation.blog.link">
              {{ 'navigation.blog' | translate }}
            </a>
          </li>
          <li class="nav-menu__item">
            <a (click)="navigation.mobileHamburgerMenuOpen = false" href="#" routerLink="/progress">
              {{ 'navigation.statistic' | translate }}
            </a>
          </li>
          <li class="nav-menu__item" *ngIf="CONFIGURATION.help.show.publicPage">
            <a [href]="faqLink" target="_blank">{{ 'navigation.help' | translate }}</a>
          </li>
        </ng-container>
        <li class="nav-menu__item nav-menu__item--separator"></li>
        <ng-container *ngIf="CONFIGURATION.navigation.loginDropDown">
          <ng-container *ngTemplateOutlet="newLoginSubNavMenuMobile"></ng-container>
        </ng-container>
        <li class="nav-menu__item" *ngIf="!headerModel.isLoggedIn && CONFIGURATION.navigation.exposeSignUpMenu">
          <a (click)="navigation.mobileHamburgerMenuOpen = false" class="btn btn--primary"
            [href]="landingPagePathFor('signUp', countryCode)">
            {{ 'navigation.sign-up' | translate }}
          </a>
        </li>
        <ng-container *ngIf="!CONFIGURATION.navigation.loginDropDown">
          <li class="nav-menu__item">
            <a (click)="navigation.mobileHamburgerMenuOpen = false" class="btn btn--primary" href="#"
              routerLink="/log-in">
              {{ 'navigation.log-in' | translate }}
            </a>
          </li>
        </ng-container>
      </ul>
    </nav>
  </header>
</div>

<!-- DIALOG -->
<!-- 2FA Log In -->
<div id="TwoFaLoginModal" class="fs-modal fs-full-height-modal" *ngIf="modal.twoFalogIn">
  <div class="fs-modal__background">
    <div class="text-right">
      <div>{{ 'form.otp.change-phone-number' | translate }}</div>
      <div>{{ 'form.otp.contact-us-here' | translate }}</div>
    </div>
  </div>
  <div class="fs-modal__content d-flex justify-content-center full-height">
    <div class="signUpModalDetailContent text-center">
      <two-fa-common [twoFaOptions]="twoFaConfig"></two-fa-common>
    </div>
  </div>
</div>
<!-- Activation Success Response -->
<div id="ActivationSuccessModal" class="signUpModal" *ngIf="modal.activationSuccess">
  <div class="modalBody">
    <div class="col-md-4 col-xs-4 signUpModalContent activation text-center">
      <div class="col-md-12 margin-top-10">
        <div class="col-md-12">
          <img align="right" src="assets/img/icon/close-icon.svg" (click)="onClickCloseAllModals()"
            style="margin-right: -20px;cursor:pointer">
        </div>
        <div class="col-md-12 activation-success content-center">
        </div>
        <div class="col-md-12 text-center heading-semi-bold font-size-28 margin-top-10">
          {{ 'form.activation.placeholder.title' | translate }}
        </div>
        <div class="col-md-12 text-center font-size-14 margin-top-10">
          <span style="color:#9b9b9b" [innerHtml]="('form.activation.placeholder.description' | translate)">
          </span>
        </div>
        <div class="col-md-12">
          <div class="line-text-middle">
          </div>
        </div>
        <div class="text-center">
          <div class="btn-rectangle btn" routerLink="/log-in">
            {{ 'form.activation.placeholder.button-success' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Activation Failed Response -->
<div id="ActivationFailedModal" class="signUpModal" *ngIf="modal.activationFailed">
  <div class="modalBody">
    <div class="col-md-4 col-xs-4 signUpModalContent activation text-center">
      <div class="col-md-12 margin-top-10">
        <div class="col-md-12">
          <img align="right" src="assets/img/icon/close-icon.svg" (click)="onClickCloseAllModals()"
            style="margin-right: -20px;cursor:pointer">
        </div>
        <div class="col-md-12 activation-failed content-center">
        </div>
        <div class="col-md-12 text-center heading-semi-bold font-size-28 margin-top-10">
          {{ 'form.activation.placeholder.title-failed' | translate }}
        </div>
        <div class="col-md-12 text-center font-size-14 margin-top-10">
          <span style="color:#9b9b9b" [innerHtml]="formModel.activation.error">
          </span>
        </div>
        <div class="col-md-12">
          <div class="line-text-middle">
          </div>
        </div>
        <div class="text-center">
          <div class="btn-rectangle btn" routerLink="/log-in">
            {{ 'form.activation.placeholder.button-failed' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Inactivity prompt -->
<div id="InactivityPromptModal" class="signUpModal" *ngIf="modal.inactivityPrompt">
  <div class="modalBackground"></div>
  <div class="modalBody">
    <div class="signUpModalContent activation text-center font-size-16 padding-null">
      <div class="padding-1rem">
        {{ 'inactivity-warning' | translate:{ timeLeftToLogout: timeLeftToLogout } }}
      </div>
    </div>
  </div>
</div>

<!-- DASHBOARD NAVIGATION - DESKTOP -->

<!-- HEADER SUBMENU TEMPLATE -->
<ng-template #fsHeaderSubmenu>
  <span *ngIf="showHelp" class="submenu-button" role="button" (click)="goToHelp()">
    {{ 'navigation.help' | translate }}
    <span class="submenu-divider">|</span>
  </span>
  <span
    *ngIf="getMemberTypeCode() === memberTypeCodes.investor ? navigationAccess?.investor.subMenu.setting : navigationAccess?.borrower.subMenu.setting"
    role="button" class="submenu-button" (click)="goToSetting()">
    {{ 'navigation.setting' | translate }}
    <span class="submenu-divider">|</span>
  </span>
  <span role="button" class="submenu-button" (click)="logOut()">
    {{ 'navigation.log-out' | translate }}
    <span class="submenu-divider" *ngIf="showFeedback">|</span>
  </span>
  <span id="feedback" role="button" class="submenu-button" (click)="goToFeedback($event)" *ngIf="showFeedback">
    {{ 'navigation.feedback' | translate }}
  </span>
</ng-template>

<!-- HEADER Profile TEMPLATE -->
<ng-template #fsHeaderProfile>
  <strong class="heading-semi-bold">{{ 'header.welcome' | translate }},</strong>
  <span class="heading-regular">{{ memberModel.fullName }}</span>
  <span *ngIf="showWarning" (click)="redirectForReverification()" class="fa fa-exclamation-circle warning-agreement"
    aria-hidden="true"></span>
</ng-template>

<ng-template #fsHeaderBalanceCash>
  <div class="fs-header-balance-cash heading-light" *ngIf="showBalanceCash">{{ 'header.balance-cash' | translate }}
    <strong class="heading-semi-bold">{{ memberModel.currency }}
      {{ memberModel.balance | number: memberModel.currencyFormat: memberModel.localeFormat }}</strong>
  </div>
</ng-template>

<nav class="header-container" *ngIf="!showPublicNavigationBar"
  [ngClass]="{ 'overlayed': showMobileLeftNavMenu, 'log-in single-stack-banner' : partialDownTimeBanner.enabled }">
  <ng-container *ngTemplateOutlet="partialDownTimeBannerTemplate"></ng-container>
  <!-- <div class="navbar-header">
      <button type="button" class="navbar-toggle pull-left" data-toggle="collapse" data-target="#scrollAffix" aria-expanded="false"
        style="padding:0 !important;">
              <i class="fa fa-bars font-size-28" (click)="showMobileLeftNavMenu = !showMobileLeftNavMenu"></i>
          </button>
      <a class="navbar-brand hidden-lg hidden-md hidden-sm" href="#" routerLink="/"></a>
      <div class="fsmk-vertical-logo content-center" style="width:50vw" routerLink="/"></div>
    </div> -->
  <div id="scrollAffix" class="mainMenu" [ngClass]="{'show': headerModel.isLoggedIn }"
    *ngIf="getMemberTypeCode() !== ''">
    <div class="container" [ngClass]="{ 'single-stack-banner' : partialDownTimeBanner.enabled }">
      <!-- SUBMENU LEFT DESKTOP -->
      <div class="col-xs-4 col-sm-4 col-md-5 col-lg-5 fs-menu-left">
        <div class="font-size-22 text-ellipsis fs-menu-header-name" [ngClass]="{ 'margin-top-10': !showMenuToggle }">
          <ng-container *ngTemplateOutlet="fsHeaderProfile; context:this"></ng-container>
        </div>
        <div class="fs-header-menu-box">
          <ng-container *ngTemplateOutlet="fsHeaderSubmenu; context:this"></ng-container>
        </div>
      </div>
      <!-- TOGGLE -->
      <div class="fs-menu"
        *ngIf="getMemberTypeCode() === memberTypeCodes.investor ? navigationAccess?.investor.showMenu : navigationAccess?.borrower.showMenu"
        [ngClass]="{ 'single-stack-banner' : partialDownTimeBanner.enabled }" (touchstart)="toggleMenu($event)"
        (click)="toggleMenu($event)" (dblclick)="toggleMenu($event)">
        <div id="dashboardnav_hype_container"
          [ngClass]="{ show : getMemberTypeCode() === memberTypeCodes.investor ? navigationAccess?.investor.showMenu : navigationAccess?.borrower.showMenu }">
          <div class="fs-menu-icon"></div>
        </div>
        <div class="fs-menu-title">
          <a href="#">{{ 'navigation.menu' | translate }}</a>
        </div>
        <div class="fs-menu-triangle"></div>
      </div>
      <!-- SUBMENU RIGHT -->
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-right fs-menu-right">
        <ng-container *ngTemplateOutlet="fsHeaderBalanceCash; context:this"></ng-container>
        <!-- REFERRAL -->
        <!-- <div class="font-size-14"
            *ngIf="(getMemberTypeCode() === memberTypeCodes.investor) && navigationAccess.investor.menu.referral">
            <span style="color:#9b9b9b">{{ 'referral.caption-1' | translate }}, </span>
            <strong role="button" (click)="showReferBox = !showReferBox;showMenuContainer = false;"><u>{{ 'referral.caption-2' | translate }}</u></strong>.
          </div> -->
        <!-- MONTHLY STATEMENTS -->
        <div class="fs-statement-link"
          *ngIf="navigationAccess?.investor.menu.statement || (navigationAccess?.borrower.menu.statement && CONFIGURATION.showTaxInvoice)">
          <strong role="button" (click)="goToStatement()">
            <u>{{ 'statement.caption' | translate }}</u>
          </strong>
        </div>
        <div class="font-size-14"
          *ngIf="showcompleteAccountActivationButton && (getMemberTypeCode() === memberTypeCodes.investor) && navigationAccess?.investor.menu.homepage">
          <span role="button" style="color:#9b9b9b" routerLink="/admin-investor">
            <u>{{ 'navigation.complete-account-activation' | translate }}</u>
          </span>
        </div>
        <div class="triangle-border top right text-left refer-friend-box" [ngClass]="{ active : showReferBox }">
          <div class="font-size-20 margin-bottom-10">
            <strong>{{ 'referral.box-title' | translate }}</strong>
          </div>
          <div class="margin-bottom-20">
            <span [innerHtml]="('referral.box-subtitle' | translate)">
            </span>
          </div>
          <div class="row margin-null">
            <div class="pull-left">
              <div class="pull-left">
                <input
                  [placeholder]="getMemberTypeCode() === memberTypeCodes.investor ? formModel.referral.investorLink + formModel.referral.code : formModel.referral.borrowerLink + formModel.referral.code"
                  [value]="getMemberTypeCode() === memberTypeCodes.investor ? formModel.referral.investorLink + formModel.referral.code : formModel.referral.borrowerLink + formModel.referral.code"
                  class="margin-right-10" style="width:8em;height: 2.5em">
              </div>
              <div
                [cbContent]="getMemberTypeCode() === memberTypeCodes.investor ? formModel.referral.investorLink + formModel.referral.code : formModel.referral.borrowerLink + formModel.referral.code"
                (cbOnSuccess)="onCopyToClipboard()" class="btn btn-primary-borrower pull-left" ngxClipboard>
                {{ 'referral.button' | translate }}
              </div>
            </div>
            <div class="referral-box pull-right">
            </div>
          </div>
          <div class="margin-top-20 margin-bottom-10">
            <span>{{ 'referral.box-social-title' | translate }}</span>
          </div>
          <div class="row margin-null">
            <div role="button" class="pull-left margin-right-20 facebook-icon" (click)="share('facebook')">
            </div>
            <div role="button" class="pull-left margin-right-20 google-plus-icon" (click)="share('google-plus')">
            </div>
            <div role="button" class="pull-left margin-right-20 linkedin-icon" (click)="share('linked-in')">
            </div>
            <div role="button" class="pull-left twitter-icon" (click)="share('twitter')">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- SUBMENU PROFILE MOBILE -->
  <!-- <div class="fs-menu-profile">
      <div class="font-size-22 text-ellipsis fs-menu-header-name" [ngClass]="{ 'margin-top-10': !showMenuToggle }"><strong class="heading-semi-bold">{{ 'header.welcome' | translate }},</strong>
        <span class="heading-regular">{{ memberModel.fullName }}</span>
      </div>
      <div class="fs-header-menu-box">
        <span *ngIf="getMemberTypeCode() === memberTypeCodes.investor ? navigationAccess.investor.subMenu.activity : navigationAccess.borrower.subMenu.activity"
              class="button-activity"
              role="button"
              (click)="showActivityBox = !showActivityBox;showMenuContainer = false">
              {{ 'navigation.activity' | translate }} |
        </span>
        <span role="button" (click)="navigateToUrl(headerModel.intercomHelp)">{{ 'navigation.help' | translate }} |</span>
        <span *ngIf="getMemberTypeCode() === memberTypeCodes.investor ? navigationAccess.investor.subMenu.setting : navigationAccess.borrower.subMenu.setting"
              role="button"
              (click)="goToSetting()">
              {{ 'navigation.setting' | translate }} |
        </span>
        <span role="button" (click)="logOut()">{{ 'navigation.log-out' | translate }}</span>
    </div> -->

  <span *ngIf="getMemberTypeCode() === memberTypeCodes.investor" class="fs-menu-container-wrapper"
    [ngClass]="{'fs-menu-container-wrapper--active' : showMenuContainer, 'my' : countryFlagCode === 'my' }">
    <div class="fs-header-profile-mobile fs-menu-container-wrapper">
      <ng-container *ngTemplateOutlet="fsHeaderProfile; context:this"></ng-container>
      <ng-container *ngTemplateOutlet="fsHeaderBalanceCash; context:this"></ng-container>
      <div class="font-size-14 text-center" (click)="reverseMenuButton();"
        *ngIf="(getMemberTypeCode() === memberTypeCodes.investor) && navigationAccess?.investor.menu.statement">
        <strong role="button" routerLink="/admin-investor/statement">
          <u>{{ 'statement.caption' | translate }}</u>
        </strong>
      </div>
    </div>
    <div class="investorMenuContainer text-center">
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.overview">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/overview" class="investor-menu-icon margin-bottom-20 overview"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.overview' | translate}}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.browse_loan">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/browse-loan" class="investor-menu-icon margin-bottom-20 investment"></div>
        <span class="investor-header-caption" [innerHTML]="( 'navigation.investment' | translate )"></span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.homepage">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();" routerLink="/admin-investor"
          class="investor-menu-icon margin-bottom-20 margin-left-20 activation" [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.account-activation' | translate}}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.portfolio">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/portfolio" class="investor-menu-icon margin-bottom-20 portfolio"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.portfolio' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.deposit">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/deposit" class="investor-menu-icon margin-bottom-20 deposit"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.deposit' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.withdrawal">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/withdrawal" class="investor-menu-icon margin-bottom-20 withdrawal"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.withdrawal' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.referral">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/referral" class="investor-menu-icon margin-bottom-20 referral"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.referral' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.subMenu.activity">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/activity" class="investor-menu-icon margin-bottom-20 activity"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.activity' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.investor.menu.sbn_retail">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-investor/sbn-retail" class="investor-menu-icon margin-bottom-20 sbn-retail"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.sbn-retail' | translate }}</span>
      </div>
    </div>

    <div class="fs-header-menu-box-mobile fs-menu-container-wrapper">
      <ng-container *ngTemplateOutlet="fsHeaderSubmenu; context:this"></ng-container>
    </div>
    <div class="modal-container" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
      [ngClass]="{'active' : showMenuContainer}">
    </div>
  </span>
  <div *ngIf="getMemberTypeCode() === memberTypeCodes.borrower" class="fs-menu-container-wrapper"
    [ngClass]="{'fs-menu-container-wrapper--active' : showMenuContainer}">
    <div class="fs-header-profile-mobile fs-menu-container-wrapper">
      <ng-container *ngTemplateOutlet="fsHeaderProfile; context:this"></ng-container>
    </div>
    <div class="row investorMenuContainer text-center" [ngClass]="{'active' : showMenuContainer}">
      <div class="item text-center" *ngIf="navigationAccess?.borrower.menu.overview">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-borrower/overview" class="investor-menu-icon overview margin-bottom-20"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.overview' | translate }}</span>
      </div>
      <div class="item text-center"
        *ngIf="navigationAccess?.borrower.menu.new_loan && !hasLandingPageFor('personalisedFinancing', countryCode) && showCreateNewLoanButton">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-borrower/new-loan" class="investor-menu-icon investment margin-bottom-20"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.new-loan' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.borrower.menu.repayment">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-borrower/repayment" class="investor-menu-icon repayment margin-bottom-20"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.repayment' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.borrower.menu.facility && showFacilityLoan">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-borrower/facility" class="investor-menu-icon facility-list margin-bottom-20"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.facility' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.borrower.menu.referral">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-borrower/referral" class="investor-menu-icon referral margin-bottom-20"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.referral' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.borrower.subMenu.activity">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-borrower/activity" class="investor-menu-icon activity margin-bottom-20"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.activity' | translate }}</span>
      </div>
      <div class="item text-center" *ngIf="navigationAccess?.borrower.menu.partner && CONFIGURATION.showPartner">
        <div role="button" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
          routerLink="/admin-borrower/partner" class="investor-menu-icon partner margin-bottom-20"
          [ngClass]="{ grayscale : false }"></div>
        <span class="investor-header-caption">{{ 'navigation.partner' | translate }}</span>
      </div>
    </div>
    <div class="fs-header-menu-box-mobile fs-menu-container-wrapper">
      <ng-container *ngTemplateOutlet="fsHeaderSubmenu; context:this"></ng-container>
    </div>
    <div class="row modal-container" (click)="reverseMenuButton();" (dblclick)="reverseMenuButton();"
      [ngClass]="{'active' : showMenuContainer}">
    </div>
  </div>
</nav>

<ng-template #partialDownTimeBannerTemplate>
  <div class="col-xs-12 header-banner-row" *ngIf="partialDownTimeBanner.enabled">
    <div class="col-xs-12 header-banner-container yellow">
      <div class="information-icon-yellow col-xs-2 padding-null"></div>
      <div class="col-xs-10 padding-null">
        <div class="col-xs-12">
          {{ partialDownTimeBanner.message }}
        </div>
      </div>
      <div class="close-icon-gray col-xs-2 pull-right padding-null" (click)="closePartialDownTimeBanner()"></div>
    </div>
  </div>
</ng-template>

<ng-template #newLoginSubNavMenuDesktop>
  <li class="nav-submenu" [ngClass]="{ 'is-open' : navigation.desktopSubMenuOpen.login }" #loginDesktopMenu>
    <span class="nav-submenu__title" tabindex="0" (click)="toggleDesktopSubMenu('login')">
      {{ 'navigation.log-in' | translate }}
    </span>

    <ng-container *ngTemplateOutlet="newLoginSubNavItems"></ng-container>
  </li>
</ng-template>

<ng-template #newLoginSubNavMenuMobile>
  <li class="nav-submenu" [ngClass]="{ 'is-open' : navigation.activeMobileSubMenu === 'log-in' }">
    <span (click)="navigation.activeMobileSubMenu = 'log-in'" class="nav-submenu__title" tabindex="0">
      {{ 'navigation.log-in' | translate }}
    </span>

    <ng-container *ngTemplateOutlet="newLoginSubNavItems"></ng-container>
  </li>
</ng-template>

<ng-template #newLoginSubNavItems>
  <div class="nav-submenu__container">
    <ul class="nav-submenu__items">
      <li class="nav-submenu__item">
        <a (click)="toggleDesktopSubMenu('login')" href="#" routerLink="/log-in/investor">
          {{ 'navigation.log-in-menu.investor' | translate }}
        </a>
      </li>
      <li class="nav-submenu__item">
        <a class="clickable" (click)="navigateToBusinessLogin()">
          {{ 'navigation.log-in-menu.borrower' | translate }}
        </a>
      </li>
    </ul>
  </div>
</ng-template>
